import { Logger, LoggerService } from "@Shared/logger";
import { OneTapOptions } from "./_models";
import { OneTapService } from "./services";

export class OneTapModuleClass {
    private Logger: Logger = LoggerService.createLogger("OneTapModuleClass");

    constructor() {
        this.Logger.trace("****  CTOR ****");
    }

    public async init(options: OneTapOptions): Promise<void> {
        this.Logger.trace("setting up One Tap Module...", options);
        try {
            await OneTapService.Instance.init(options);
            return Promise.resolve();
        } catch (error) {
            throw error;
        }
    }

    public prompt(): Promise<void> {
        return OneTapService.Instance.promptManually();
    }
}

export const OneTapModule = new OneTapModuleClass();
